import { TBookingContext } from '@providers/booking/types'
import { LocationClientDto, TExternalAccountTypes } from 'service-api/src/types/api'

export const getExternalAccountByType = (location: LocationClientDto, accountType: TExternalAccountTypes) => {
  if (typeof location === 'undefined') {
    return null
  }
  const externalAccount = location.externalAccountLocations?.find((ea) => ea.externalAccount?.type === accountType)
  return externalAccount ? externalAccount.externalAccount : null
}

export const getExternalAccountReach = (location: LocationClientDto) =>
  getExternalAccountByType(location, 'REACH_TENANT')?.externalReferenceId

export const getHasSharedCRM = (location?: LocationClientDto): boolean | null => {
  if (!location) return null
  const isDelegateLocation = location.isDelegate
  const isParticipantLocation = !!location.delegateLocationId
  return isDelegateLocation || isParticipantLocation
}

export const isWaitlistEnabled = (state: TBookingContext): boolean => {
  return state.config.serviceType?.waitlistEnabled !== 'DISABLED'
}
